module.exports = __webpack_public_path__ + "img/three.5255c76f.svg";